<template>
  <div class="context-leaderboard-live">
    <div class="context-leaderboard-live__inner">
      <BlockListLeaderboard
        :users="users"
        v-bind="leaderboardContent"
      />
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line import/no-extraneous-dependencies
import io from 'socket.io-client';

defineProps({
    leaderboardContent: {
        type: Object,
        default: () => {},
    },
});

const users = ref([]);
const socket = ref(null);
const { triggerConfetti } = useConfetti();
const isMounted = ref(false);
const isInitial = ref(true);
const { public: publicRuntimeConfig } = useRuntimeConfig();

onMounted(() => {
    socket.value = io(publicRuntimeConfig.API_URL);
    isMounted.value = true;
});

watch(() => socket.value, (newValue) => {
    if (newValue) {
        newValue.on('liveLeaderboard', (data) => {
            if (!isArrayNotEmpty(data)) return;

            const allUsers = data;

            // Limit to 15 users
            if (allUsers.length > 15) {
                allUsers.splice(15);
            }

            users.value = allUsers.map((user) => ({
                username: user.username,
                points: user.points,
                isMe: user.isMe,
                position: user.position,
                clearname: `${user.prename} ${user.name}`,
            }));

            if (isMounted.value && !isInitial.value) {
                triggerConfetti();
            }

            isInitial.value = false;
        });
    }
});
</script>

<style lang="scss" scoped>
.context-leaderboard-live {
    @include wrapper-layout;
    @include grid-layout;

    margin-bottom: var(--m-bottom--big);
}

.context-leaderboard-live__inner {
    @include default-content-columns('wide');
    @include box-default;

    ::v-deep(.block-auth-user-leaderboard__entry) {
        &:first-child {
            padding-top: 0;
            .block-auth-user-leaderboard__header {
                padding-top: 0;
            }
        }
    }
}
</style>
